import { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import makeAnimated from "react-select/animated";
import { getApiData } from "../../../helpers/AxiosInstance";
// @ts-ignore
import { tw } from "@careinfo/tailwind";

const animatedComponents = makeAnimated();

const MultipleSelectField = (props: any) => {
  const {
    name,
    setValue,
    label,
    url,
    value = [],
    clearErrors,
    errors,
    props: otherProps,
  } = props;

  const limit = 10;

  const handleChange = (options: any[]) => {
    setValue(name, options, {
      shouldDirty: true,
      shouldValidate: true,
    });
    clearErrors?.(name);
  };
  const loadOptions = async (inputValue: string) => {
    const response = await getApiData(url, {
      limit: 10,
      offset: 0,
      search: inputValue,
      ...otherProps,
    });

    const options =
      response?.data?.results?.map((item: any) => ({
        label: `${item.code}-${item.name}`,
        value: item.id,
        code: item.code,
        name: item.name,
      })) ?? [];

    return [
      ...(value ?? []).filter(
        (sel: any) => !options.some((opt) => opt.value === sel.value)
      ),
      ...options,
    ];
  };

  return (
    <div className={tw`mt-2`}>
      <label>{label}</label>
      <AsyncSelect
        isMulti
        cacheOptions
        defaultOptions
        loadOptions={loadOptions}
        value={(value ?? []).map((item: any) => ({
          ...item,
          label: item.label || `${item.code}-${item.name}`,
        }))}
        onChange={handleChange}
        components={animatedComponents}
        closeMenuOnSelect={false}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{
          control: (base) => ({
            ...base,
            backgroundColor: "#EEF5F4",
            border: "none",
          }),
          menuPortal: (base) => ({
            ...base,
            zIndex: 100000,
          }),
        }}
      />

      {errors && (
        <p className={tw`text-red-500 text-xs my-1`}>{errors.message}</p>
      )}
    </div>
  );
};

export default MultipleSelectField;
